export interface TaxIdSublineSource {
  number?: string | number | null;
  tax_authority_uid?: string | null;
  cufe?: string | null;
  cae?: string | null;
}

/**
 * Identificador fiscal (UUID del CFDI en MX, CUFE en CO, CAE en AR) a mostrar como
 * sublínea del número de factura en las tablas. Devuelve "" cuando coincide
 * con el propio número (MX pre-backfill: number === UUID) para no repetirlo.
 * La comparación es case-insensitive porque el case de la fuente original
 * puede variar antes de que corra el backfill.
 */
export function taxIdSubline(item: TaxIdSublineSource): string {
  const taxId = item.tax_authority_uid || item.cufe || item.cae;
  if (!taxId) return "";
  const number = item.number != null ? String(item.number) : "";
  return taxId.toUpperCase() !== number.toUpperCase() ? taxId : "";
}
